import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Typography from '@classify/react-core-components/Typography';
import Stack from '@classify/react-core-components/Stack';
import { translate } from '@openclassrooms/translations';
import { styled } from '@classify/react-core-components/styles';
import { RichContent } from '@openclassrooms/rich-content';
import preRequisitsIllustration from '../images/preRequisits.svg';
import { useCourseContext } from '../../_contexts/CourseContext';
const ILLUSTRATION_SIZE = 200;
const RootStack = styled(Stack)(() => ({
  flexDirection: 'column',
  width: '100%'
}));
const StyledTitle = styled(Typography)(({
  theme
}) => ({
  width: '100%',
  paddingBottom: theme.spacing(1),
  borderBottom: `1px solid ${theme.palette.divider}`
}));
const ContentStack = styled(Stack)(({
  theme
}) => ({
  flexDirection: 'column-reverse',
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    columnGap: theme.spacing(2),
    paddingTop: theme.spacing(3)
  }
}));
const PreRequisitsImage = styled(Image)({
  width: ILLUSTRATION_SIZE,
  minWidth: ILLUSTRATION_SIZE,
  height: ILLUSTRATION_SIZE
});
const Prerequisites = () => {
  const $ = _c(5);
  const {
    course
  } = useCourseContext();
  const {
    prerequisite
  } = course;
  if (!prerequisite) {
    return null;
  }
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: "100%"
    };
    t1 = <PreRequisitsImage alt="" src={preRequisitsIllustration} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <StyledTitle variant="h3" component="h2">{translate("course.overview.requirements.title")}</StyledTitle>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== prerequisite) {
    t3 = <ContentStack gap={4} sx={t0}>{t1}<RootStack>{t2}<RichContent content={prerequisite} /></RootStack></ContentStack>;
    $[3] = prerequisite;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export default Prerequisites;